import { css } from "vite-css-in-js"
import { defineComponent, type ReactiveComponent } from "vue-utils"
import { useEditingMarriageClaimState } from "../state"
import { getBooleanDisplayValue, isEmptyStringOrNull } from "./utils"

const formSectionStyling = css`
	display: grid;
	align-items: center;
	grid-template-columns: repeat(2, 1fr);
	gap: 0.5rem 2rem;

	h6 {
		margin-bottom: 0;
	}

	div[data-span="2"] {
		grid-column-start: span 2;
	}

	@media (width < 992px) {
		grid-template-columns: 1fr;
	}
`

const AdditionalInformation: ReactiveComponent = () => {
	const state = useEditingMarriageClaimState()

	return () => (
		<div class={formSectionStyling}>
			<div class="d-flex gap-1">
				<h6>Validity:</h6>
				<h6 class="fw-bold">{state.fullClaim.Validity}</h6>
			</div>
			<div class="d-flex gap-1">
				<h6>Failure Reason:</h6>
				<h6 class="fw-bold">
					{isEmptyStringOrNull(state.fullClaim.FailureReason) ? `N/A` : state.fullClaim.FailureReason}
				</h6>
			</div>
			<div class="d-flex gap-1">
				<h6>Opted In To Uniform Benefits?:</h6>
				<h6 class="fw-bold">{getBooleanDisplayValue(state.fullClaim.OptedInToUniformBenefits, "Unknown")}</h6>
			</div>
			<div class="d-flex gap-1">
				<h6>Claim ID:</h6>
				<h6 class="fw-bold">{state.fullClaim.ClaimId ?? "Unknown"}</h6>
			</div>
			<div class="d-flex gap-1">
				<h6>Date Created:</h6>
				<h6 class="fw-bold">{state.fullClaim.DateCreated.toGBDateTimeString()}</h6>
			</div>
			<div class="d-flex gap-1">
				<h6>Date Updated:</h6>
				<h6 class="fw-bold">{state.fullClaim.DateUpdated.toGBDateTimeString()}</h6>
			</div>
		</div>
	)
}

export default defineComponent(AdditionalInformation)
